// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300italic,400italic,600italic,700italic,800italic,400,300,600,700,800&amp;subset=latin,cyrillic-ext,greek-ext,vietnamese);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: 'Open Sans', sans-serif;
    color: #545454;
    text-rendering: optimizeLegibility;
}

h1, h2, h3, h4, h5, h6, p {
    margin-top: 0;
}

fieldset {
    margin-bottom: 20px;
}

legend {
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 15px;
}
a {
    text-decoration: none;
}

.loading i {
    animation: fa-spin 2s linear infinite;
}

.loading i:before {
    content: "\\f1ce";
}

#container {
    min-height: 100vh;
    width: 100%;
    position: relative;
    background: #f6f6f6;
    overflow: hidden;
}
.container-fluid {
    padding: 0 20px;
}

#header {
    border-bottom: 1px solid #d8d8d8;
    box-shadow: 0px 0px 3px #ccc;
    z-index: 1000;
    margin: 0;
    padding: 0;
}

#header .navbar-brand {
    transition: 0.3s all;
    width: 235px;
    text-align: left;
    padding: 0px 0px;
}

/* Desktop */
@media (min-width: 992px) {
    #header .navbar-brand {
        padding: 5px 0px;
    }
}
#header .navbar-brand img {
    padding: 1px 0px;
    max-width: 170px;
}

#header .navbar-nav > li > .nav-link {
    color: #6D6D6D;
}

#header .navbar-nav li > .nav-link:hover, #header .navbar-nav li.show > .nav-link {
    background: #EEEEEE;
}

/* Header Notification */
#header #header-notification .nav-link {
    padding: 12px 15px 0px 15px;
    line-height: 33px;
}

#header #header-notification > .nav-link .badge {
    position: absolute;
    top: 7px;
    right: 12px;
    padding: 3px 4px 2px 4px;
    opacity: 0.8;
    border-radius: 6px;
}

/* Desktop */
@media (min-width: 992px) {
    #header #header-notification .nav-link {
        padding: 10px 15px 0px 15px;
        line-height: 50px;
    }

    #header #header-notification > .nav-link .badge {
        top: 14px;
        right: 11px;
    }
}

#header #header-notification > .nav-link > i.fa-bell {
    font-size: 24px;
}

/* Header Profile */
#header #header-profile .nav-link {
    padding: 0px 15px;
    line-height: 45px;
}

#header #header-profile img {
    max-width: 30px;
}

/* Desktop */
@media (min-width: 992px) {
    #header #header-profile .nav-link {
        padding: 0px 10px;
        line-height: 60px;
    }

    #header #header-profile img {
        max-width: 35px;
    }
}

/* Header Logout */
#header #header-logout > .nav-link {
    padding: 6px 20px 0px 20px;
    line-height: 39px;
}

#header #header-logout > .nav-link > i.fa-sign-out-alt {
    font-size: 20px;
}

/* Desktop */
@media (min-width: 992px) {
    #header #header-logout > .nav-link {
        padding: 0px 20px 0px 15px;
        line-height: 60px;
    }

    #header #header-logout > .nav-link > i.fa-sign-out-alt {
        font-size: 15px;
    }
}

/* Menu Button */
#button-menu {
    font-size: 25px;
    padding: 0px 16px;
    margin: 2px;
    cursor: pointer;
    color: #6D6D6D;
}

/* Desktop */
@media (min-width: 992px) {
    #button-menu {
        padding: 10px 16px;
    }
}

#column-left {
    width: 250px;
    height: 100%;
    overflow-y: scroll;
    background-color: #03396c;
    position: absolute;
    top: 0px;
    left: -250px;
    padding-top: 67px;
    min-height: 100vh;
}

#column-left::-webkit-scrollbar {
    width: 5px;
    background-color: rgba(200, 200, 200, 0);
}

#column-left::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(128, 139, 156, 0.2);
}

#content {
    padding-bottom: 40px;
    /* min-height: calc(100vh - 80px); */
}

#column-left, #content, #footer {
    transition: all 0.3s;
}

#column-left + #content, #column-left + #content + #footer {
    position: relative;
    left: 0px;
}

#column-left.active {
    left: 0px;
}

#column-left.active + #content, #column-left.active + #content + #footer {
    left: 235px;
}

/* Desktop */
@media (min-width: 992px) {
    #column-left {
        left: 0px;
    }

    #column-left + #content, #column-left + #content + #footer {
        left: 0px;
        margin-left:250px;
        padding-bottom: 10px;
    }

    #column-left.active + #content, #column-left.active + #content + #footer {
        left: 0px;
        margin-left: 235px;
    }
}

/* Navigation */
#navigation {
    text-transform: uppercase;
    padding: 15px 15px 15px 15px;
    color: #FFFFFF;
    background: #03396c;
    display: block;
}

/* Menu */
#menu, #menu ul, #menu li {
    padding: 0;
    margin: 0;
    list-style: none;
}

#menu {
    margin-bottom: 25px;
}

#menu li a {
    text-decoration: none;
    display: block;
    padding: 10px;
    cursor: pointer;
    border-bottom: 0px solid #515151;
}

#menu li a.parent:after {
    font-family: 'Font Awesome 5 Free';
    font-weight: 600;
    float: right;
    margin-right: 8px;
}

#menu li a.parent:after {
    content: "\\f107";
}

#menu li a.collapsed:after {
    content: "\\f105";
}

/* 1st lvl */
#menu > li {
    position: relative;
    border-bottom: 1px solid #ffffff1f;
}

#menu > li > a {
    font-size: 13px;
    color: #ffffff;
    padding-left: 20px;
    border-bottom: 0px solid #585858;
}
#menu > li > a:hover {
    background-color: #ed716c;
    /* color: #000; */
}

#menu > li > a > i {
    font-size: 14px;
    width: 18px;
    margin-right: 5px;
    /*color: #b3cbdd;*/
}

#menu > li.active > a {
    /* color: #000000; */
    background-color: #ed716c;
}

#menu > li > ul {
    background-color: #292929;
}

/* 2nd lvl */
#menu li li a {
    color: #ffffff;
}

#menu li li a:before {
    font-family: 'Font Awesome 5 Free';
    content: "\\f101";
    font-weight: 900;
    font-size: 13px;
    margin-left: 10px;
    margin-right: 10px;
    transition: margin ease 0.5s;
}

#menu li li a:hover:before {
    margin-right: 20px;
}

#menu li li a:hover {
    color: #ffffff;
    background-color: #ed716c;
}
#menu li li.active > a {
    color: #ffffff;
    background-color: #0e120e;
}

#menu li ul a {
    padding-left: 20px;
}

#menu li li ul a {
    padding-left: 40px;
}

#menu li li li ul a {
    padding-left: 60px;
}

#menu li li li li ul a {
    padding-left: 80px;
}

#stats {
    border-radius: 2px;
    color: #808b9c;
    background: #2e3a47;
    margin: 15px 20px;
    padding: 5px 0;
}

#stats ul, #stats li {
    padding: 0;
    margin: 0;
    list-style: none;
}

#stats li {
    font-size: 11px;
    color: #9d9d9d;
    padding: 5px 10px;
    border-bottom: 1px dotted #373737;
}

#stats div:first-child {
    margin-bottom: 4px;
}

#stats .progress {
    height: 3px;
    margin-bottom: 0;
}

/* footer */
#footer {
    height: auto;
    text-align: center;
}

.page-header {
    vertical-align: middle;
    margin: 20px 0 15px 0;
    padding: 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #e9e9e9;
}
.page-header h1 {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 30px;
    color: #272727;
    display: inline-block;
    margin-bottom: 15px;
    text-shadow: 0 1px #fff;
}

/* Navs
/* Tabs*/
.nav-tabs > li > a {
    color: #a5a5a5;
}

.nav-tabs > li > a:hover {
    border-color: #eee #eee #ddd;
}

.nav-tabs {
    margin-bottom: 25px;
}

.nav-tabs li.nav-item a.active {
    color: #333;
}

.form-label, .col-form-label {
    font-weight: bold;
}

.form-switch-lg {
    font-size: 26px;
    min-height: 36px;
    line-height: 36px;
}

@media (min-width: 992px) {
    .col-form-label {
        text-align: right;
    }
}

.row.mb-3 + .row.mb-3 {
    padding-top: 1rem;
    border-top: 1px solid #ededed;
}

.form-control:hover {
    border: 1px solid #b9b9b9;
    border-top-color: #a0a0a0;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
}

div.required .col-form-label:not(span):before, td.required:before {
    content: '* ';
    color: #F00;
    font-weight: bold;
}

.image {
    width: 12rem;
}

.table thead td span[data-toggle='tooltip']:after, label.form-label span:after {
    font-family: 'Font Awesome 5 Free';
    font-weight: 600;
    content: "\\f059";
    color: #1E91CF;
    margin-left: 4px;
}

.table thead td {
    font-weight: bold;
}

.table thead > tr > td, .table tbody > tr > td {
    vertical-align: middle;
}

.table a.asc:after {
    font-family: 'Font Awesome 5 Free';
    font-weight: 600;
    content: " \\f106";
}

.table a.desc:after {
    font-family: 'Font Awesome 5 Free';
    font-weight: 600;
    content: " \\f107";
}

.pagination {
    margin: 0;
}

/* Cards */
.card {
    border-radius: 0px;
}

.card-header > i {
    margin-right: 5px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.card-body {

}

.bootstrap-datetimepicker-widget {
    position: absolute;
    float: right;
    z-index: 9999;
    height: 200px;
    width: 250px;
}


/* Tiles */
.tile {
    margin-bottom: 15px;
    border-radius: 3px;
    color: #FFFFFF;
    transition: all 1s;
}

.tile-primary {
    background-color: #03396c;
}

.tile-success {
    background-color: #53b953;
}

.tile-warning {
    background-color: #f3aa41;
}

.tile-danger {
    background-color: #e45847;
}

.tile:hover {
    opacity: 0.95;
}

.tile a {
    color: #FFFFFF;
}

.tile-heading {
    padding: 5px 8px;
    text-transform: uppercase;
    color: #FFF;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, .4);
    background-color: rgba(255, 255, 255, 0.1);
}

.tile .tile-heading .pull-right {
    transition: all 1s;
    opacity: 0.7;
}

.tile:hover .tile-heading .pull-right {
    opacity: 1;
}

.tile-body {
    padding: 15px;
    color: #FFFFFF;
    line-height: 48px;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, .4);
}

.tile .tile-body i {
    font-size: 50px;
    opacity: 0.3;
    transition: all 1s;
}

.tile:hover .tile-body i {
    color: #FFFFFF;
    opacity: 1;
}

.tile .tile-body h2 {
    font-size: 42px;
}

.tile-footer {
    padding: 5px 8px;
    background-color: rgba(0, 0, 0, 0.1);
}

.jqvmap-label {
    z-index: 999;
}

.card-body .jqvmap-zoomin, .jqvmap-zoomout {
    padding: 0px;
}
/* Filemanager Folder Size */
#filemanager .fa-folder.fa-5x {
    font-size: 10.5em;
}

#extension-list {
    color: #4b525d;
}

#extension-list h2 {
    margin-top: 54px;
    margin-bottom: 44px;
}

#extension-list section {
    border: 1px solid #ddd;
}

#extension-list section > div {
    position: relative;
}

#extension-list section > div + div {
    border-top: 1px solid #ddd;
    padding: 10px;
}

#extension-list section:hover {
    border: 1px solid #1b80c2;
}

#extension-list > .row {
    margin-top: 30px;
}

#extension-list > .row > * {
    margin-bottom: 30px;
}

#extension-list .extension-preview {
    min-height: 150px;
}

#extension-list .extension-preview img {
    margin: 0 auto;
}

#extension-list .extension-preview .extension-description {
    position: absolute;
    background-color: rgba(36, 45, 55, 0.9);
    color: #fff;
    padding: 10px;
    font-size: 14px;
    line-height: 16px;
    opacity: 0;
    height: 100%;
    width: 100%;
}

#extension-list .extension-preview .extension-description:hover {
    opacity: 1;
}

#extension-list i {
    color: #10b4e9;
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
    #extension-list .extension-preview {
        min-height: 123px;
    }

    #extension-list .extension-preview .extension-description {
        font-size: 12.5px;
        padding: 6px;
    }

    #extension-list .extension-preview img {
        margin: 0 auto;
    }

    #extension-list .extension-name {
        min-height: 105px;
    }

    #extension-list .extension-name p {
        color: #000;
        margin-bottom: 0;
        font-weight: 600;
    }

    #extension-list .extension-name p:first-child {
        font-size: 17px;
    }

    #extension-list .extension-name p span {
        color: #4b525d;
        font-weight: 400;
    }

    #extension-list .extension-name h4 a, #extension-list .extension-name p a {
        color: #000;
    }

    #extension-list .extension-name + div > .row {
        margin-top: 0;
    }

    @media screen and (min-width: 992px) and (max-width: 1199px) {
        #extension-list .extension-name + div > .row {
            font-size: 14px;
        }
    }

    #extension-list span {
        font-weight: 600;
    }
}

#marketplace-extension-info #banner img {
    margin-left: auto;
    margin-right: auto;
}

#marketplace-extension-info .extension-review {
    border-top: 5px solid #1b80c2;
    padding-top: 50px;
    margin-top: 50px;
    margin-bottom: 50px;
}

#marketplace-extension-info .nav-tabs {
    font-size: 14px;
}

#marketplace-extension-info .nav-tabs + .tab-content {
    margin-top: 30px;
    margin-bottom: 30px;
}

#marketplace-extension-info iframe {
    width: 100%;
    height: 500px;
}

@media screen and (max-width: 767px) {
    #marketplace-extension-info iframe {
        height: 350px;
    }
}

#marketplace-extension-info #buy {
    color: #4b525d;
}

#marketplace-extension-info #buy #price {
    color: #000;
    font-size: 20px;
    padding-top: 15px;
    padding-bottom: 5px;
}

#marketplace-extension-info #buy i {
    color: #10b4e9;
}

#marketplace-extension-info #buy hr {
    border-color: #ddd;
    margin: 10px 0;
}

#marketplace-extension-info #sales {
    color: #4b525d;
}

#marketplace-extension-info #sales i {
    color: #7ec239;
    margin-right: 10px;
    font-size: 24px;
}

#marketplace-extension-info #sales strong {
    font-size: 24px;
}

#marketplace-extension-info #comment {
    color: #4b525d;
}

#marketplace-extension-info #comment i {
    margin-right: 10px;
    font-size: 22px;
}

#marketplace-extension-info #comment strong {
    font-size: 22px;
}

#marketplace-extension-info .reply > div {
    margin-top: 15px;
}

#marketplace-extension-info .well .media {
    line-height: 1.2;
}

#marketplace-extension-info .well .media .media-body {
    padding-top: 6px;
}

#marketplace-extension-info .well .media .media-body span {
    font-size: 24px;
    font-weight: 600;
}

#marketplace-extension-info .well .media .media-body small {
    color: #878f9a;
}

@media screen and (max-width: 992px) {
    #marketplace-extension-info .container-fluid {
        padding-bottom: 30px;
    }
}

.list-check {
    list-style: none;
}

.list-check li::before {
    font-family: 'Font Awesome 5 Solid';
    content: "\\f00c";
    margin-left: -30px;
    width: 29px;
    display: inline-block;
    color: #7ebd38;
}

.list-check.list-color-blue li::before {
    color: #02afe9;
}
td {
    position: relative;
}
.image-thumbs {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
}

.image-thumbs .single-thumb {
    position: relative;
    /* border: 1px solid #c1c1c1; */
    text-align: center;
}
.image-thumbs .single-thumb button {
    position: absolute;
    right: 0;
    top: 0;
    background: red;
    color: #fff;
    border: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 8px;
    padding: 0;
    min-width: inherit;
}

.image-thumbs .single-image-thumb {
    width: 100px;
    cursor: zoom-in;
}

.image-thumbs .single-image-thumb img {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheet/stylesheet.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;;AAEA;IAEI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,YAAY;AACZ;IACI;QACI,2BAA2B;QAC3B,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA,YAAY;AACZ;IACI;QACI,SAAS;IACb;;IAEA;QACI,SAAS;QACT,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;AACJ;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;QACQ;AACR;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IAEzB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA,UAAU;AACV;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;;AAEA;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,YAAY;AAChB;;;AAGA,UAAU;AACV;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA,4BAA4B;AAC5B;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Open+Sans:300italic,400italic,600italic,700italic,800italic,400,300,600,700,800&amp;subset=latin,cyrillic-ext,greek-ext,vietnamese);\n\nhtml, body {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    font-family: 'Open Sans', sans-serif;\n    color: #545454;\n    text-rendering: optimizeLegibility;\n}\n\nh1, h2, h3, h4, h5, h6, p {\n    margin-top: 0;\n}\n\nfieldset {\n    margin-bottom: 20px;\n}\n\nlegend {\n    border-bottom: 1px solid #e5e5e5;\n    margin-bottom: 15px;\n}\na {\n    text-decoration: none;\n}\n\n.loading i {\n    -webkit-animation: fa-spin 2s linear infinite;\n    animation: fa-spin 2s linear infinite;\n}\n\n.loading i:before {\n    content: \"\\f1ce\";\n}\n\n#container {\n    min-height: 100vh;\n    width: 100%;\n    position: relative;\n    background: #f6f6f6;\n    overflow: hidden;\n}\n.container-fluid {\n    padding: 0 20px;\n}\n\n#header {\n    border-bottom: 1px solid #d8d8d8;\n    box-shadow: 0px 0px 3px #ccc;\n    z-index: 1000;\n    margin: 0;\n    padding: 0;\n}\n\n#header .navbar-brand {\n    transition: 0.3s all;\n    width: 235px;\n    text-align: left;\n    padding: 0px 0px;\n}\n\n/* Desktop */\n@media (min-width: 992px) {\n    #header .navbar-brand {\n        padding: 5px 0px;\n    }\n}\n#header .navbar-brand img {\n    padding: 1px 0px;\n    max-width: 170px;\n}\n\n#header .navbar-nav > li > .nav-link {\n    color: #6D6D6D;\n}\n\n#header .navbar-nav li > .nav-link:hover, #header .navbar-nav li.show > .nav-link {\n    background: #EEEEEE;\n}\n\n/* Header Notification */\n#header #header-notification .nav-link {\n    padding: 12px 15px 0px 15px;\n    line-height: 33px;\n}\n\n#header #header-notification > .nav-link .badge {\n    position: absolute;\n    top: 7px;\n    right: 12px;\n    padding: 3px 4px 2px 4px;\n    opacity: 0.8;\n    border-radius: 6px;\n}\n\n/* Desktop */\n@media (min-width: 992px) {\n    #header #header-notification .nav-link {\n        padding: 10px 15px 0px 15px;\n        line-height: 50px;\n    }\n\n    #header #header-notification > .nav-link .badge {\n        top: 14px;\n        right: 11px;\n    }\n}\n\n#header #header-notification > .nav-link > i.fa-bell {\n    font-size: 24px;\n}\n\n/* Header Profile */\n#header #header-profile .nav-link {\n    padding: 0px 15px;\n    line-height: 45px;\n}\n\n#header #header-profile img {\n    max-width: 30px;\n}\n\n/* Desktop */\n@media (min-width: 992px) {\n    #header #header-profile .nav-link {\n        padding: 0px 10px;\n        line-height: 60px;\n    }\n\n    #header #header-profile img {\n        max-width: 35px;\n    }\n}\n\n/* Header Logout */\n#header #header-logout > .nav-link {\n    padding: 6px 20px 0px 20px;\n    line-height: 39px;\n}\n\n#header #header-logout > .nav-link > i.fa-sign-out-alt {\n    font-size: 20px;\n}\n\n/* Desktop */\n@media (min-width: 992px) {\n    #header #header-logout > .nav-link {\n        padding: 0px 20px 0px 15px;\n        line-height: 60px;\n    }\n\n    #header #header-logout > .nav-link > i.fa-sign-out-alt {\n        font-size: 15px;\n    }\n}\n\n/* Menu Button */\n#button-menu {\n    font-size: 25px;\n    padding: 0px 16px;\n    margin: 2px;\n    cursor: pointer;\n    color: #6D6D6D;\n}\n\n/* Desktop */\n@media (min-width: 992px) {\n    #button-menu {\n        padding: 10px 16px;\n    }\n}\n\n#column-left {\n    width: 250px;\n    height: 100%;\n    overflow-y: scroll;\n    background-color: #03396c;\n    position: absolute;\n    top: 0px;\n    left: -250px;\n    padding-top: 67px;\n    min-height: 100vh;\n}\n\n#column-left::-webkit-scrollbar {\n    width: 5px;\n    background-color: rgba(200, 200, 200, 0);\n}\n\n#column-left::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: rgba(128, 139, 156, 0.2);\n}\n\n#content {\n    padding-bottom: 40px;\n    /* min-height: calc(100vh - 80px); */\n}\n\n#column-left, #content, #footer {\n    transition: all 0.3s;\n}\n\n#column-left + #content, #column-left + #content + #footer {\n    position: relative;\n    left: 0px;\n}\n\n#column-left.active {\n    left: 0px;\n}\n\n#column-left.active + #content, #column-left.active + #content + #footer {\n    left: 235px;\n}\n\n/* Desktop */\n@media (min-width: 992px) {\n    #column-left {\n        left: 0px;\n    }\n\n    #column-left + #content, #column-left + #content + #footer {\n        left: 0px;\n        margin-left:250px;\n        padding-bottom: 10px;\n    }\n\n    #column-left.active + #content, #column-left.active + #content + #footer {\n        left: 0px;\n        margin-left: 235px;\n    }\n}\n\n/* Navigation */\n#navigation {\n    text-transform: uppercase;\n    padding: 15px 15px 15px 15px;\n    color: #FFFFFF;\n    background: #03396c;\n    display: block;\n}\n\n/* Menu */\n#menu, #menu ul, #menu li {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n#menu {\n    margin-bottom: 25px;\n}\n\n#menu li a {\n    text-decoration: none;\n    display: block;\n    padding: 10px;\n    cursor: pointer;\n    border-bottom: 0px solid #515151;\n}\n\n#menu li a.parent:after {\n    font-family: 'Font Awesome 5 Free';\n    font-weight: 600;\n    float: right;\n    margin-right: 8px;\n}\n\n#menu li a.parent:after {\n    content: \"\\f107\";\n}\n\n#menu li a.collapsed:after {\n    content: \"\\f105\";\n}\n\n/* 1st lvl */\n#menu > li {\n    position: relative;\n    border-bottom: 1px solid #ffffff1f;\n}\n\n#menu > li > a {\n    font-size: 13px;\n    color: #ffffff;\n    padding-left: 20px;\n    border-bottom: 0px solid #585858;\n}\n#menu > li > a:hover {\n    background-color: #ed716c;\n    /* color: #000; */\n}\n\n#menu > li > a > i {\n    font-size: 14px;\n    width: 18px;\n    margin-right: 5px;\n    /*color: #b3cbdd;*/\n}\n\n#menu > li.active > a {\n    /* color: #000000; */\n    background-color: #ed716c;\n}\n\n#menu > li > ul {\n    background-color: #292929;\n}\n\n/* 2nd lvl */\n#menu li li a {\n    color: #ffffff;\n}\n\n#menu li li a:before {\n    font-family: 'Font Awesome 5 Free';\n    content: \"\\f101\";\n    font-weight: 900;\n    font-size: 13px;\n    margin-left: 10px;\n    margin-right: 10px;\n    transition: margin ease 0.5s;\n}\n\n#menu li li a:hover:before {\n    margin-right: 20px;\n}\n\n#menu li li a:hover {\n    color: #ffffff;\n    background-color: #ed716c;\n}\n#menu li li.active > a {\n    color: #ffffff;\n    background-color: #0e120e;\n}\n\n#menu li ul a {\n    padding-left: 20px;\n}\n\n#menu li li ul a {\n    padding-left: 40px;\n}\n\n#menu li li li ul a {\n    padding-left: 60px;\n}\n\n#menu li li li li ul a {\n    padding-left: 80px;\n}\n\n#stats {\n    border-radius: 2px;\n    color: #808b9c;\n    background: #2e3a47;\n    margin: 15px 20px;\n    padding: 5px 0;\n}\n\n#stats ul, #stats li {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n#stats li {\n    font-size: 11px;\n    color: #9d9d9d;\n    padding: 5px 10px;\n    border-bottom: 1px dotted #373737;\n}\n\n#stats div:first-child {\n    margin-bottom: 4px;\n}\n\n#stats .progress {\n    height: 3px;\n    margin-bottom: 0;\n}\n\n/* footer */\n#footer {\n    height: auto;\n    text-align: center;\n}\n\n.page-header {\n    vertical-align: middle;\n    margin: 20px 0 15px 0;\n    padding: 0;\n    padding-bottom: 5px;\n    border-bottom: 1px solid #e9e9e9;\n}\n.page-header h1 {\n    font-family: 'Open Sans', sans-serif;\n    font-weight: 600;\n    font-size: 30px;\n    color: #272727;\n    display: inline-block;\n    margin-bottom: 15px;\n    text-shadow: 0 1px #fff;\n}\n\n/* Navs\n/* Tabs*/\n.nav-tabs > li > a {\n    color: #a5a5a5;\n}\n\n.nav-tabs > li > a:hover {\n    border-color: #eee #eee #ddd;\n}\n\n.nav-tabs {\n    margin-bottom: 25px;\n}\n\n.nav-tabs li.nav-item a.active {\n    color: #333;\n}\n\n.form-label, .col-form-label {\n    font-weight: bold;\n}\n\n.form-switch-lg {\n    font-size: 26px;\n    min-height: 36px;\n    line-height: 36px;\n}\n\n@media (min-width: 992px) {\n    .col-form-label {\n        text-align: right;\n    }\n}\n\n.row.mb-3 + .row.mb-3 {\n    padding-top: 1rem;\n    border-top: 1px solid #ededed;\n}\n\n.form-control:hover {\n    border: 1px solid #b9b9b9;\n    border-top-color: #a0a0a0;\n    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n}\n\ndiv.required .col-form-label:not(span):before, td.required:before {\n    content: '* ';\n    color: #F00;\n    font-weight: bold;\n}\n\n.image {\n    width: 12rem;\n}\n\n.table thead td span[data-toggle='tooltip']:after, label.form-label span:after {\n    font-family: 'Font Awesome 5 Free';\n    font-weight: 600;\n    content: \"\\f059\";\n    color: #1E91CF;\n    margin-left: 4px;\n}\n\n.table thead td {\n    font-weight: bold;\n}\n\n.table thead > tr > td, .table tbody > tr > td {\n    vertical-align: middle;\n}\n\n.table a.asc:after {\n    font-family: 'Font Awesome 5 Free';\n    font-weight: 600;\n    content: \" \\f106\";\n}\n\n.table a.desc:after {\n    font-family: 'Font Awesome 5 Free';\n    font-weight: 600;\n    content: \" \\f107\";\n}\n\n.pagination {\n    margin: 0;\n}\n\n/* Cards */\n.card {\n    border-radius: 0px;\n}\n\n.card-header > i {\n    margin-right: 5px;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.card-body {\n\n}\n\n.bootstrap-datetimepicker-widget {\n    position: absolute;\n    float: right;\n    z-index: 9999;\n    height: 200px;\n    width: 250px;\n}\n\n\n/* Tiles */\n.tile {\n    margin-bottom: 15px;\n    border-radius: 3px;\n    color: #FFFFFF;\n    transition: all 1s;\n}\n\n.tile-primary {\n    background-color: #03396c;\n}\n\n.tile-success {\n    background-color: #53b953;\n}\n\n.tile-warning {\n    background-color: #f3aa41;\n}\n\n.tile-danger {\n    background-color: #e45847;\n}\n\n.tile:hover {\n    opacity: 0.95;\n}\n\n.tile a {\n    color: #FFFFFF;\n}\n\n.tile-heading {\n    padding: 5px 8px;\n    text-transform: uppercase;\n    color: #FFF;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, .4);\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.tile .tile-heading .pull-right {\n    transition: all 1s;\n    opacity: 0.7;\n}\n\n.tile:hover .tile-heading .pull-right {\n    opacity: 1;\n}\n\n.tile-body {\n    padding: 15px;\n    color: #FFFFFF;\n    line-height: 48px;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, .4);\n}\n\n.tile .tile-body i {\n    font-size: 50px;\n    opacity: 0.3;\n    transition: all 1s;\n}\n\n.tile:hover .tile-body i {\n    color: #FFFFFF;\n    opacity: 1;\n}\n\n.tile .tile-body h2 {\n    font-size: 42px;\n}\n\n.tile-footer {\n    padding: 5px 8px;\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.jqvmap-label {\n    z-index: 999;\n}\n\n.card-body .jqvmap-zoomin, .jqvmap-zoomout {\n    padding: 0px;\n}\n/* Filemanager Folder Size */\n#filemanager .fa-folder.fa-5x {\n    font-size: 10.5em;\n}\n\n#extension-list {\n    color: #4b525d;\n}\n\n#extension-list h2 {\n    margin-top: 54px;\n    margin-bottom: 44px;\n}\n\n#extension-list section {\n    border: 1px solid #ddd;\n}\n\n#extension-list section > div {\n    position: relative;\n}\n\n#extension-list section > div + div {\n    border-top: 1px solid #ddd;\n    padding: 10px;\n}\n\n#extension-list section:hover {\n    border: 1px solid #1b80c2;\n}\n\n#extension-list > .row {\n    margin-top: 30px;\n}\n\n#extension-list > .row > * {\n    margin-bottom: 30px;\n}\n\n#extension-list .extension-preview {\n    min-height: 150px;\n}\n\n#extension-list .extension-preview img {\n    margin: 0 auto;\n}\n\n#extension-list .extension-preview .extension-description {\n    position: absolute;\n    background-color: rgba(36, 45, 55, 0.9);\n    color: #fff;\n    padding: 10px;\n    font-size: 14px;\n    line-height: 16px;\n    opacity: 0;\n    height: 100%;\n    width: 100%;\n}\n\n#extension-list .extension-preview .extension-description:hover {\n    opacity: 1;\n}\n\n#extension-list i {\n    color: #10b4e9;\n}\n\n@media screen and (min-width: 992px) and (max-width: 1199px) {\n    #extension-list .extension-preview {\n        min-height: 123px;\n    }\n\n    #extension-list .extension-preview .extension-description {\n        font-size: 12.5px;\n        padding: 6px;\n    }\n\n    #extension-list .extension-preview img {\n        margin: 0 auto;\n    }\n\n    #extension-list .extension-name {\n        min-height: 105px;\n    }\n\n    #extension-list .extension-name p {\n        color: #000;\n        margin-bottom: 0;\n        font-weight: 600;\n    }\n\n    #extension-list .extension-name p:first-child {\n        font-size: 17px;\n    }\n\n    #extension-list .extension-name p span {\n        color: #4b525d;\n        font-weight: 400;\n    }\n\n    #extension-list .extension-name h4 a, #extension-list .extension-name p a {\n        color: #000;\n    }\n\n    #extension-list .extension-name + div > .row {\n        margin-top: 0;\n    }\n\n    @media screen and (min-width: 992px) and (max-width: 1199px) {\n        #extension-list .extension-name + div > .row {\n            font-size: 14px;\n        }\n    }\n\n    #extension-list span {\n        font-weight: 600;\n    }\n}\n\n#marketplace-extension-info #banner img {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n#marketplace-extension-info .extension-review {\n    border-top: 5px solid #1b80c2;\n    padding-top: 50px;\n    margin-top: 50px;\n    margin-bottom: 50px;\n}\n\n#marketplace-extension-info .nav-tabs {\n    font-size: 14px;\n}\n\n#marketplace-extension-info .nav-tabs + .tab-content {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n#marketplace-extension-info iframe {\n    width: 100%;\n    height: 500px;\n}\n\n@media screen and (max-width: 767px) {\n    #marketplace-extension-info iframe {\n        height: 350px;\n    }\n}\n\n#marketplace-extension-info #buy {\n    color: #4b525d;\n}\n\n#marketplace-extension-info #buy #price {\n    color: #000;\n    font-size: 20px;\n    padding-top: 15px;\n    padding-bottom: 5px;\n}\n\n#marketplace-extension-info #buy i {\n    color: #10b4e9;\n}\n\n#marketplace-extension-info #buy hr {\n    border-color: #ddd;\n    margin: 10px 0;\n}\n\n#marketplace-extension-info #sales {\n    color: #4b525d;\n}\n\n#marketplace-extension-info #sales i {\n    color: #7ec239;\n    margin-right: 10px;\n    font-size: 24px;\n}\n\n#marketplace-extension-info #sales strong {\n    font-size: 24px;\n}\n\n#marketplace-extension-info #comment {\n    color: #4b525d;\n}\n\n#marketplace-extension-info #comment i {\n    margin-right: 10px;\n    font-size: 22px;\n}\n\n#marketplace-extension-info #comment strong {\n    font-size: 22px;\n}\n\n#marketplace-extension-info .reply > div {\n    margin-top: 15px;\n}\n\n#marketplace-extension-info .well .media {\n    line-height: 1.2;\n}\n\n#marketplace-extension-info .well .media .media-body {\n    padding-top: 6px;\n}\n\n#marketplace-extension-info .well .media .media-body span {\n    font-size: 24px;\n    font-weight: 600;\n}\n\n#marketplace-extension-info .well .media .media-body small {\n    color: #878f9a;\n}\n\n@media screen and (max-width: 992px) {\n    #marketplace-extension-info .container-fluid {\n        padding-bottom: 30px;\n    }\n}\n\n.list-check {\n    list-style: none;\n}\n\n.list-check li::before {\n    font-family: 'Font Awesome 5 Solid';\n    content: \"\\f00c\";\n    margin-left: -30px;\n    width: 29px;\n    display: inline-block;\n    color: #7ebd38;\n}\n\n.list-check.list-color-blue li::before {\n    color: #02afe9;\n}\ntd {\n    position: relative;\n}\n.image-thumbs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 30px;\n}\n\n.image-thumbs .single-thumb {\n    position: relative;\n    /* border: 1px solid #c1c1c1; */\n    text-align: center;\n}\n.image-thumbs .single-thumb button {\n    position: absolute;\n    right: 0;\n    top: 0;\n    background: red;\n    color: #fff;\n    border: none;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    font-size: 8px;\n    padding: 0;\n    min-width: inherit;\n}\n\n.image-thumbs .single-image-thumb {\n    width: 100px;\n    cursor: zoom-in;\n}\n\n.image-thumbs .single-image-thumb img {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
